/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_6_QInputs */

const en_pc_faq_6_q = /** @type {(inputs: Pc_Faq_6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which systems does it run on?`)
};

const zh_pc_faq_6_q = /** @type {(inputs: Pc_Faq_6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持哪些系统？`)
};

/**
* | output |
* | --- |
* | "Which systems does it run on?" |
*
* @param {Pc_Faq_6_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_6_q = /** @type {((inputs?: Pc_Faq_6_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_6_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_6_q(inputs)
	return zh_pc_faq_6_q(inputs)
});
export { pc_faq_6_q as "pc.faq.6.q" }